import { render, staticRenderFns } from "./TrainingPerformanceSelector.vue?vue&type=template&id=146037d2&"
import script from "./TrainingPerformanceSelector.vue?vue&type=script&lang=ts&"
export * from "./TrainingPerformanceSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VSlider})
